import React from 'react';
import { Skeleton } from '@mui/material';

const FieldsSidebarSkeleton = () => {
  const renderFieldSkeleton = () => (
    <div className="draggable-field">
      <span className="draggable-field-left-border" style={{ background: 'var(--purple-p-50)' }}></span>
      <div className="draggable-field-content">
        <Skeleton variant="text" width={216} sx={{ fontSize: '16px' }} />
      </div>
    </div>
  );

  const renderSectionHeader = () => (
    <div className="section-header-skeleton">
      <Skeleton variant="text" width={152} height={20} sx={{ marginBottom: '4px', borderRadius: '4px' }} />
      <Skeleton variant="text" width={216} height={20} />
    </div>
  );

  return (
    <div className="fields-sidebar">
      {/* Dynamic Fields Section */}
      <div className="field-section">
        {renderSectionHeader()}
        <div className="fields-list">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} style={{ marginBottom: '8px' }}>
              {renderFieldSkeleton()}
            </div>
          ))}
        </div>
      </div>

      {/* Font Section */}
      <div className="field-section">
        {renderSectionHeader()}
        <div className="fields-list">
          {[1, 2].map((i) => (
            <div key={i} style={{ marginBottom: '8px' }}>
              {renderFieldSkeleton()}
            </div>
          ))}
        </div>
      </div>

      {/* Signature Section */}
      <div className="field-section">
        {renderSectionHeader()}
        <div className="fields-list">
          {[1, 2].map((i) => (
            <div key={i} style={{ marginBottom: '8px' }}>
              {renderFieldSkeleton()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FieldsSidebarSkeleton;
